import { get } from './ajax';
const $ = window.$;

$(document).on('change', '.js-filter-date input', function () {
    console.log('Test')
    const data = {};

    $("[class*='js-filter']").find('[name]').each(function () {
        data[$(this).attr('name')] = $(this).val();
    });

    function success(data) {
        $('.dd').replaceWith($(data).find('.dd'));
        if ($('.js-paginate')) {
            $('.js-paginate').replaceWith($(data).find('.js-paginate'));
        }
    }

    get(window.location.href, data, success);
});
